import { ReactNode } from "react";

import { SegmentedProgress } from "~/shared/components/ui/SegmentedProgress";
import { tw } from "~/utils";

interface FormContentContainerProps {
  children: ReactNode;
  className?: string;
  stepId?: string;
  showProgress?: boolean;
  noPadding?: boolean;
}

export const FormContentContainer = ({
  children,
  className,
  stepId,
  showProgress = true,
  noPadding = false,
}: FormContentContainerProps) => {
  return (
    <div
      className={tw(
        // Base styles
        "flex w-full max-w-[570px] flex-col items-start gap-4 bg-white",
        // Rounded top, desktop width
        "rounded-t-lg sm:w-[570px]",
        // Padding (conditional)
        !noPadding && "px-6 pt-6 pb-32 sm:w-[570px] sm:px-10 sm:pt-8 sm:pb-6",
        className,
      )}
    >
      {stepId && showProgress && (
        <SegmentedProgress currentStepId={stepId} className="mb-2" />
      )}
      {children}
    </div>
  );
};
